import { INewRelicConfig } from '@assess/browser/new-relic';

export const newRelic: INewRelicConfig = {
  accountId: window.APP_CONFIG.ACCOUNT_ID,
  customerId: window.APP_CONFIG.CUSTOMER_ID,
  environmentId: window.APP_CONFIG.ENVIRONMENT_ID,
  enabled: window.APP_CONFIG.NEW_RELIC_BROWSER_ENABLED === 'true',
  version: window.APP_CONFIG.APP_VERSION,
};
